<script>
  // prettier-ignore
  const ICON_MAP = {
    close: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
    search: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z",
    play: "M232 464C360.13 464 464 360.13 464 232C464 103.87 360.13 0 232 0C103.87 0 0 103.87 0 232C0 360.13 103.87 464 232 464ZM338.057 250.11C346.895 245.007 346.895 232.25 338.057 227.148L178.971 135.299C170.133 130.197 159.086 136.575 159.086 146.78L159.086 330.477C159.086 340.682 170.133 347.06 178.971 341.958L338.057 250.11Z",
  };

  const ICON_WIDTHS = {
    close: 320,
    search: 512,
    play: 512,
  };

  export let name;
  export let width = 32;
  export let onClick = null;
</script>

<svg
  viewBox="0 0 {ICON_WIDTHS[name]} 512"
  class="cna-icon"
  {width}
  on:click={onClick}
>
  <path fill-rule="evenodd" d={ICON_MAP[name]} />
</svg>
